import styled from 'styled-components';
import CheggSVG from '../primitives/svg';
import { iconSizeToPixelValue, iconSizeToRemValue } from '../shared';

/**
 * Base SvgIcon component
 *
 * Sized using `rem` units. Pixel equivalents in param info.
 *
 * Do not set height & width manually; use `size` instead.
 *
 * @param props.size xsmall: 16px, small (default): 24px, medium: 32px, large: 48px
 */
export var SvgIcon = styled(CheggSVG).attrs(function (props) {
  var pixelValue = iconSizeToPixelValue[props.size ||
  /* istanbul ignore next */
  'small'];
  return {
    height: pixelValue,
    width: pixelValue
  };
}).withConfig({
  componentId: "mho0kh-0"
})(["", ""], function (props) {
  var remValue = iconSizeToRemValue[props.size ||
  /* istanbul ignore next */
  'small'];
  return "\n      height: ".concat(remValue, "rem;\n      width: ").concat(remValue, "rem;\n      // without setting min-values, the icons can shrink below desired size when used in flexbox\n      min-height: ").concat(remValue, "rem;\n      min-width: ").concat(remValue, "rem;\n      padding: 2px;\n      box-sizing: border-box;\n      overflow: visible; // this is to fix svg cut issue on zoom\n    ");
});
SvgIcon.displayName = 'SvgIcon';
SvgIcon.defaultProps = {
  size: 'small',
  viewBox: '0 0 44 44',
  'aria-hidden': 'true'
};
export default SvgIcon;